<template>
  <div>
    <ol class="flex column">
      <li v-for="(contractTerm, contractTermKey) in contractTerms" :key="contractTermKey">{{contractTerm}}</li>
    </ol>
  </div>
</template>
<script>
export default {
  data () {
    return {
      contractTerms: ['version', 'name', '+variables', '+events', '+structs', '+mappings', '+modifiers', 'constructor', '+functions', 'return']
    }
  }
}
</script>